import { render, staticRenderFns } from "./makeAppointmentInfo.vue?vue&type=template&id=8ebaafe0&scoped=true&"
import script from "./makeAppointmentInfo.vue?vue&type=script&lang=js&"
export * from "./makeAppointmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebaafe0",
  null
  
)

export default component.exports